import {
  AdminInputPlaceholderStyled,
  CopyTextWithIcon,
  Div,
  Label,
  lightTheme,
} from '@vgrubs/components';

/**
 * A labeled, copyable value using the design-system CopyTextWithIcon (click-to-copy).
 * Used for the Grubhub password (partner sets it in Grubhub; admins can copy it).
 */
export const CopyField = ({
  label,
  value,
}: {
  label?: string;
  value: string;
}) => (
  <Div $flex $column $gap="4px">
    {label && <Label label={label} />}
    <AdminInputPlaceholderStyled>
      <CopyTextWithIcon
        text={value}
        copy={value}
        $m="0"
        $bold
        color={lightTheme.darkGray}
      />
    </AdminInputPlaceholderStyled>
  </Div>
);
